import { persist } from 'easy-peasy'

import { userModel } from './user/index'
import { QoSAdminModel } from './admin-qos'
import { mainAdmin } from './main-admin'
import { sdocAdminModel } from './sdoc-admin'
import { sdocUserModel } from './sdoc-user'
import { operatorModel } from './operator'
import { poaModel } from './poa'
import { appModel } from './app-state'
import { dataSetRecordModel } from './dataset-record'

export const storeModel = persist(
	{
		userModel: userModel,
		QoSAdminModel: QoSAdminModel,
		mainAdminModel: mainAdmin,
		appModel: appModel,
		sdocAdminModel: sdocAdminModel,
		sdocUserModel: sdocUserModel,
		poa: poaModel,
		operatorModel: operatorModel,
		dataSetRecordModel: dataSetRecordModel,
	},
	{
		allow: [
			'userModel',
			'QoSAdminModel',
			'mainAdminModel',
			'appModel',
			'sdocAdminModel',
			'sdocUserModel',
		],
		storage: 'localStorage',
	}
)
